/**
 * "Reset to the AI result" (JF 2026-10-09): when the AI prices a sheet (the estimate, or "re-price from the checklist")
 * a snapshot of that result is kept in sheet.ai.base. After manual edits the AM can go back to it in one click.
 * The snapshot leaves out the sketch (the picture is kept on reset) and UI-only state.
 */
import { aiSnapshot, type Sheet } from "@ic/engine";

// the snapshot itself is in the engine: the server's estimate jobs make it too (JF 2026-10-16)
export { aiSnapshot, withAiBase } from "@ic/engine";

/** True when the sheet differs from the AI result it carries. */
export const editedSinceAi = (s: Sheet): boolean => !!s.ai?.base && aiSnapshot(s) !== s.ai.base;

/** The sheet as the AI produced it, keeping the current sketch, open / closed state and the snapshot itself. */
export function resetToAi(s: Sheet): Sheet {
  const base = s.ai?.base;
  if (!base) return s;
  const b = JSON.parse(base) as Sheet;
  return { ...b, sketch: s.sketch, ai: b.ai ? { ...b.ai, base, open: s.ai?.open } : null };
}
